module.exports = __webpack_public_path__ + "img/mic.4de80aeb.svg";